import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../api/server";
import Toaster from "../common/Toaster";
import dashlogo from "../../assets/img/dashbarlogo.png";
import logo from "../../assets/img/hlogo.png";
import dayjs from "dayjs";
import StatusPill from "../common/StatusPill";

export default function AuditTrailPDF() {
  //   const token = "8669F361-1CC2-4987-A3C7-31F98BCC5E9D";
  const { token } = useParams();

  const navigate = useNavigate();

  const [summary, setSummary] = useState({});
  const [eventData, setEventData] = useState({});
  const [inspectionRefNo, setInspectionRefNo] = useState("");
  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(false);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  /*--------------
  FETCH AUDIT TRAIL DATA
  --------------*/
  useEffect(() => {
    const fetchAuditTrail = async () => {
      try {
        setLoading(true);

        const { data } = await http.get(`/api/Anonymous/qref/${token}`);

        const firstEvent = data?.events?.[0];
        if (firstEvent?.inspectionReferenceNumber) {
          setInspectionRefNo(firstEvent.inspectionReferenceNumber);
        }

        setSummary(data?.summaries?.[0] || {});
        setEventData(data?.events?.[0] || {});

        const formattedSteps =
          data?.events?.map((item) => ({
            title: item.eventType,
            date: item.eventDate,
            boxText: item.performedBy
              ? `${item.eventType} by - ${item.performedBy}`
              : item.eventType,
          })) || [];

        setSteps(formattedSteps);
      } catch (err) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString:
            err?.response?.data?.message || "Failed to load audit trail",
        });
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchAuditTrail();
    }
  }, [token]);

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-light border-bottom dashboard_nav p-0">
        <div
          className="d-flex align-items-center"
          style={{
            backgroundColor: "white",
            height: "68px",
            position: "fixed",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
            left: "0",
            right: "0",
            top: "0",
            paddingLeft: "20px",
          }}
        >
          <img src={logo} className="logoheader ms-0" alt="logo" />
          <p className="mt-4 ms-2 fw-semibold">FIRE INSPECT </p>
        </div>
      </nav>

      <div className="dashboard_body_main ms-2 me-2">
        <Toaster
          show={toastData.toastShow}
          toastType={toastData.toastType}
          title={toastData.toastString}
          theme="dark"
          position="top-center"
          closeButton={closeButton}
        />

        <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
          {/* HEADER */}
          <div className="dashboard_header">
            <h2 className="mb-0">Door Inspection History</h2>
            <p className="header-description mb-0">
              Track the complete timeline of your site inspection
            </p>
          </div>

          {/* SUMMARY CARD */}
          <div
            className="card mt-4 p-3 rounded-4 mb-4 orange-box d-flex gap-3 flex-row align-items-center justify-content-between"
            style={{ height: "9.5rem" }}
          >
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-evenly text-center py-4">
                <div>
                  <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                    1
                  </h1>
                  <p className="fw-semibold mb-0">Total Doors</p>
                </div>

                <div className="col-6 col-sm-4 col-lg-2 mb-1">
                  <img src={dashlogo} alt="Inspector" height="100" />
                </div>

                <div>
                  <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                    {summary?.totalCriticalIssues || 0}
                  </h1>
                  <p className="fw-semibold mb-0">Total Critical Issues</p>
                </div>

                <div>
                  <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                    {summary?.totalNonCompliantIssues || 0}
                  </h1>
                  <p className="fw-semibold mb-0">Total Non-Compliant Issues</p>
                </div>
              </div>
            </div>
          </div>

          {/* PROPERTY INFO */}
          <div className="resident-card mb-3">
            <div className=" flex-sm-row align-items-center ">
              <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h5 className="justifyStart fw-semibold mb-0 ">
                    {summary?.buildingName || summary?.propertyName}
                  </h5>

                  <p className="justifyCenter mb-0 mt-1">
                    {/* <StatusPill status="Completed" /> */}
                    <StatusPill status={summary?.doorStatus} />
                  </p>
                </div>

                <p className="justifyStart text mb-0 mt-1">
                  <b>Location : </b>
                    {summary?.buildingName ? summary?.propertyName + summary?.doorLocation : summary?.doorLocation}
                </p>

                <div className="d-flex justify-content-between align-items-center w-100 mt-4 mb-4 text-black">
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ color: "#525254" }}>
                      Inspection Reference No :
                    </span>
                    <span>{inspectionRefNo || "-"}</span>
                  </div>

                  <p className="d-flex align-items-center mb-0 gap-2">
                    <span style={{ color: "#525254" }}>
                      Door Reference No :
                    </span>
                    <span>{eventData?.doorReferenceNumber}</span>
                  </p>

                  <p className="d-flex align-items-center mb-0 gap-2">
                    <span style={{ color: "#525254" }}>
                      Inspection Managed By :
                    </span>
                    <span>{summary?.inspectionManagedBy}</span>
                  </p>
                </div>
              </div>
              <div></div>
            </div>
          </div>

          {/* TIMELINE */}
          <div className="resident-card mb-3">
            <div className=" flex-sm-row align-items-center ">
              <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                <p className="text-start">
                  <b>Inspection Timeline</b>
                </p>
                <div className="timeline">
                  {loading ? (
                    <p>Loading timeline...</p>
                  ) : steps.length > 0 ? (
                    steps.map((step, index) => (
                      <div className="timeline-item-row" key={index}>
                        {/* LEFT SIDE: icon + title + date */}
                        <div className="timeline-left">
                          <div className="timeline-icon">
                            {step.icon === "dot" ? (
                              <div className="dot"></div>
                            ) : (
                              // <i className={step.icon}></i>
                              <div className="exact-check-icon">
                                <i className="fa-solid fa-check"></i>
                              </div>
                            )}
                          </div>
                        </div>

                        <div
                          className="inspection-box text-start p-3"
                          style={{
                            backgroundColor: "#F9F9F9",
                            border: "1px solid #E5E5E5",
                          }}
                        >
                          <div className="timeline-info">
                            <div
                              className={`inspection-title-after ${
                                step.highlight ? "text-danger fw-semibold" : ""
                              }`}
                            >
                              <div className="d-flex align-items-center">
                                <span>{step.boxText}</span>
                              </div>
                            </div>

                            <div className="inspection-date text">
                              {/* {step.date} */}
                              {step.date
                                ? dayjs(step.date, [
                                    "DD-MMM-YYYY hh:mm A",
                                    "YYYY-MM-DDTHH:mm:ss",
                                  ])
                                    .format("DD-MMM-YYYY hh:mm A")
                                    .toUpperCase()
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No booking history found.</p>
                  )}
                </div>
                <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      handleBack();
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
